import React from 'react'
import Typography from '@material-ui/core/Typography'
import LayoutPage from '../../hoc/LayoutPage/LayoutPage'
import program from '../../assets/26/Программа УОМШ-2026-new.pdf'

const Program = () => (
  <LayoutPage headling='Программа конференции'>
    <Typography variant='body1' paragraph>
      <a href={program} target='_blank' rel='noopener noreferrer'>Открыть программу в PDF</a>
    </Typography>
    <iframe
      src={program}
      title='Программа конференции УОМШ-2026'
      style={{ width: '100%', height: '80vh', minHeight: 500, border: 0 }}
    />
  </LayoutPage>
)

export default Program
